import { render, staticRenderFns } from "./FilterPrivateCategory.vue?vue&type=template&id=362ac070&scoped=true"
import script from "./FilterPrivateCategory.vue?vue&type=script&lang=ts"
export * from "./FilterPrivateCategory.vue?vue&type=script&lang=ts"
import style0 from "./FilterPrivateCategory.vue?vue&type=style&index=0&id=362ac070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362ac070",
  null
  
)

export default component.exports